import Map from './map';
import MapInfo from './info';
import MapWithClusters from './map-with-clusters';

const rexOfficeLngLat = [153.047189, -27.452625];

export { Map, MapInfo, MapWithClusters, rexOfficeLngLat };
